// Import angular modules
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

// Import pipes module
import { PipesModule } from '../pipes/pipes.module';

// Import components
import { CurrencyInputComponent } from './currency-input/currency-input.component';
import { DropdownInputComponent } from './dropdown-input/dropdown-input.component';
import { MultiLineTextInputComponent } from './multi-line-text-input/multi-line-text-input.component';
import { InputFieldComponent } from './input-field/input-field.component';
import { PercentInputComponent } from './percent-input/percent-input.component';
import { CheckboxFieldComponent } from './checkbox-field/checkbox-field.component';

@NgModule({
    declarations: [
        CurrencyInputComponent,
        DropdownInputComponent,
        MultiLineTextInputComponent,
        InputFieldComponent,
        PercentInputComponent,
        CheckboxFieldComponent
    ],
    exports: [
        CurrencyInputComponent,
        DropdownInputComponent,
        MultiLineTextInputComponent,
        InputFieldComponent,
        PercentInputComponent,
        CheckboxFieldComponent
    ],
    imports: [
        CommonModule,
        PipesModule,
        FormsModule
    ]
})
export class ComponentsModule { }
